import * as React from "react";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { WideActionButton } from "../../actionButton/ActionButton";

export interface IJobCreatedViewProps {
    hideModal:typeof hideModal;
    textToScreen?:string;
}

const JobCreatedView: React.SFC<IJobCreatedViewProps> = ({hideModal,textToScreen}) => {
   

    const buttonCloseAction = () => {
        hideModal();
    }
    return (
        <div style = {{'display': 'flex', 'flexDirection': 'column'}}>  
            <i className="ms-Icon ms-Icon--Completed" style={{color:'green',alignSelf: 'anchor-center',padding: '2vh',fontSize: 'xx-large'}}/>       
            <div className="loadingView">
                <div className="loadingViewText" style={{color:'green'}} > {textToScreen} </div>
            </div>
            <div style = {{'display': 'flex', 'flexDirection': 'row','justifyContent': 'flex-end'}}>
                <WideActionButton
                buttonText="Close"
                buttonAction={buttonCloseAction}
                disabled={false}
                className="button btn-defaultPrimary" />
            </div>
            
            
        </div>
        
    );
};

export default JobCreatedView;